/**
 * Notification API endpoints.
 */

import type { NotificationAction, NotificationType } from "@speakai/shared";
import { apiClient } from "@/lib/api/client";

export interface NotificationParams {
  page: number;
  pageSize: number;
  sortBy?: string;
  sortDir?: string;
  startDate?: string;
  endDate?: string;
  filterUserId?: string;
  description?: string;
  action?: NotificationAction;
  type?: NotificationType;
}

export interface NotificationItem {
  _id: string;
  description: string;
  type: NotificationType;
  action: NotificationAction;
  /** A labelId when mediaType is label, otherwise the file, recorder or folder the row opens */
  mediaId?: string;
  mediaType?: NotificationType;
  transactionType?: string;
  isRead: boolean;
  createdAt: string;
  user?: {
    _id: string;
    firstName: string;
    lastName: string;
    picture: string;
  };
}

export interface NotificationListResponse {
  notificationList: NotificationItem[];
  totalCount: number;
  totalUnReadCount: number;
}

function buildQueryString(params: Record<string, unknown>): string {
  return Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
    .join("&");
}

export const notificationApi = {
  getNotifications(params: NotificationParams) {
    const qs = buildQueryString(params as unknown as Record<string, unknown>);
    return apiClient.get<NotificationListResponse>(`/notification?${qs}`);
  },

  markAllAsRead() {
    return apiClient.put<{ message: string }>("/notification", null);
  },
};
